module.exports = __webpack_public_path__ + "static/media/Subaru_logo.3505da4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Subaru_logo.svg
// module id = 329
// module chunks = 0